import { useState } from 'react';
import PropTypes from 'prop-types';
import useInvoice from 'Hooks/useInvoice';
import PreviewFile from 'Components/Molecules/PreviewFile/PreviewFile';
import InvoiceQuickEditorDrawerPreviewEmpty from './InvoiceQuickEditorDrawerPreviewEmpty';
import ThumbnailFile from 'Components/Molecules/ThumbnailFile/ThumbnailFile';

import {
    useFloating,
    useInteractions,
    useRole,
    useDismiss,
    FloatingPortal,
    FloatingOverlay,
    FloatingFocusManager,
} from '@floating-ui/react';
import IconButton from 'Components/Atoms/IconButtonBare';
import Icon from 'Components/Atoms/Icon/Icon';

const download = (url, fileName) => {
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

const getFileName = (string) => {
    try {
        const url = new URL(string);
        const path = url.pathname;
        const fileName = path.split('/').pop();
        return fileName;
    } catch (error) {
        return '';
    }
};

function PreviewFullScreen(props) {
    const { id, open, onClose } = props;
    const { invoice, isLoading } = useInvoice(id);

    const { floating, context } = useFloating({
        open,
        onOpenChange: (open) => {
            if (!open) onClose();
        },
    });

    const { getFloatingProps } = useInteractions([useRole(context, { role: 'dialog' }), useDismiss(context)]);

    return (
        <FloatingPortal>
            {open && (
                <FloatingOverlay lockScroll style={{ zIndex: 999999 }}>
                    <FloatingFocusManager context={context}>
                        <div
                            {...getFloatingProps({
                                ref: floating,
                                className: 'bg-white w-full h-screen relative',
                            })}
                        >
                            <div className="absolute top-4 right-4 z-10">
                                <IconButton onClick={onClose}>
                                    <Icon name="minimize" size={20} color="rgba(32,32,32, .5)" />
                                </IconButton>
                            </div>

                            <PreviewFile
                                loading={isLoading}
                                url={invoice?.file_url}
                                className="h-screen"
                                onDownload={() => {
                                    const fileName = getFileName(invoice?.file_url);
                                    download(invoice?.file_url, fileName);
                                }}
                            />
                        </div>
                    </FloatingFocusManager>
                </FloatingOverlay>
            )}
        </FloatingPortal>
    );
}

PreviewFullScreen.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default function InvoiceQuickEditorDrawerPreviewMobile(props) {
    const { id } = props;
    const [openPreview, setOpenPreview] = useState(false);
    const { invoice, isLoading } = useInvoice(id);

    if (!isLoading && !invoice?.file_url) {
        return <InvoiceQuickEditorDrawerPreviewEmpty compactMode />;
    }

    return (
        <>
            {openPreview && <PreviewFullScreen id={id} open={openPreview} onClose={() => setOpenPreview(false)} />}

            <ThumbnailFile loading={isLoading} url={invoice?.file_url} onMaximize={() => setOpenPreview(true)} />
        </>
    );
}

InvoiceQuickEditorDrawerPreviewMobile.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    compactMode: PropTypes.bool,
};
